export default __webpack_public_path__ + "static/media/PT4.80dff23d.webp";